//src/app/routes/ClientRoutes.tsx
import Orders from 'app/features/orders';
import Payments from 'app/features/payments';
import CardSuccess from 'app/features/payments/redirectionPages/cardSuccess';
import PaymentFailed from 'app/features/payments/redirectionPages/paymentFailed';
import PaymentSuccessful from 'app/features/payments/redirectionPages/paymentSuccessful';
import Questionnaires from 'app/features/questionnaires';
import TaxReturnCheckout from 'app/features/questionnaires/checkout';
import CreateQuestionnaire from 'app/features/questionnaires/create';
import ShowQuestionnaire from 'app/features/questionnaires/show';
import AddServices from 'app/features/services/addService';
import DashboardLayout from 'app/layout/dashboardLayout';
import { Route } from 'react-router-dom';
import { useAuth } from 'utils/AuthProvider';
import ProtectedRoutes from 'utils/ProtectedRoutes';
import AccountantDetailsRoutes from './AccountantDetailsRoutes';
import ClientProfileRotues from './ClientProfileRotues';
import DocumentsRoutes from './DocumentsRoutes';
import HomeRoute from './HomeRoute';
import MessagesRoutes from './MessagesRoutes';
import NotificationsRoutes from './NotificationsRoutes';
import ServicesRoutes from './ServicesRoutes';
import TaskRoutes from './TaskRoutes';
import TaxEstimatesRoutes from './TaxEstimatesRoutes';
import TaxExtensionsRoutes from './TaxExtensionsRoutes';
import FincenReportsRoutes from './FincenReportsRoutes';
import QuickBooksCallback from 'Components/Quickbooks/QuickbooksCallback';
export default function ClientRoutes() {
  const { isClient } = useAuth();
  if (!isClient) return null;

  return (
    <>
      <Route path="/quickbooks/callback" element={<QuickBooksCallback />} />
      <Route element={<ProtectedRoutes user="CLIENT" />}>
        <Route
          path="/dashboard"
          element={<DashboardLayout internalPadding={false} />}
        >
          {HomeRoute()}

          <Route path="questionnaires">
            <Route path="" element={<Questionnaires />} />
            <Route path="create" element={<CreateQuestionnaire />} />

            <Route
              path=":questionnaireId/download"
              element={<ShowQuestionnaire preview={true} />}
            />
            <Route
              path=":questionnaireId/preview"
              element={<ShowQuestionnaire preview={true} />}
            />
            <Route path=":questionnaireId/*" element={<ShowQuestionnaire />} />
            <Route path=":projectId/checkout" element={<TaxReturnCheckout />} />
          </Route>

          {ServicesRoutes()}
          {DocumentsRoutes()}
          {TaskRoutes()}
          {NotificationsRoutes()}
          {MessagesRoutes()}
          {ClientProfileRotues()}
          {AccountantDetailsRoutes()}
          {TaxEstimatesRoutes()}
          {TaxExtensionsRoutes()}
          {FincenReportsRoutes()}
          <Route path="payments" element={<Payments />} />
          <Route path="payments/add-card/success" element={<CardSuccess />} />
          <Route path="payments/payment-failed" element={<PaymentFailed />} />
          <Route
            path="payments/payment-success"
            element={<PaymentSuccessful />}
          />
          <Route path="orders" element={<Orders />} />

          <Route path="services/add-service" element={<AddServices />} />
        </Route>
      </Route>
    </>
  );
}
